<template>
  <div>
    <div v-if="!bottomDrawEnabled"
         class="right-sidebar-desktop"
         v-bind:class="{'remove-white-background':(!bottomDrawEnabled && shouldDetachBets)}">
      <v-navigation-drawer
        right
        absolute
        floating
        :hide-overlay="true"
        :value="1"
        permanent
        v-bind:class="{
          'is-desktop-betslip':!bottomDrawEnabled,
          'is-mobile-betslip':bottomDrawEnabled}"
        width="360"
        height="auto"

      >
        <LiveCenter></LiveCenter>


      </v-navigation-drawer>

      <TraderBets v-if="(!bottomDrawEnabled && !shouldDetachBets && isTrader && isInitialStateReady)"></TraderBets>
      <BetsView v-if="(!bottomDrawEnabled && !shouldDetachBets && !isTrader && isInitialStateReady)"></BetsView>

      <v-navigation-drawer v-if="shouldDetachBets && isInitialStateReady"
                           right
                           fixed
                           floating
                           :hide-overlay="true"
                           permanent
                           v-bind:class="{
                         'is-desktop-betslip':(!bottomDrawEnabled && !shouldDetachBets),
                         'is-desktop-betslip-detached':(!bottomDrawEnabled && shouldDetachBets),}"
                           width="360"
                           height="auto"

      >
        <v-expansion-panels v-if="shouldDetachBets && isInitialStateReady"
                            v-model="betsDrawerActive"

        >
          <v-expansion-panel :key="1">
            <v-expansion-panel-header expand-icon="krypt-arrow-down">
              <div class="detached-bets-header">
                <span v-if="!isTrader">{{ $t('bets.myBets') | removeDiacriticsFromUppercase }}</span>
                <span v-if="isTrader">{{ $t('trader.forTraders') | removeDiacriticsFromUppercase }}</span>
                <div class="bets-indicator bets-tab-count" v-if="betslipBets.length >0">
                  <span>{{betslipBets.length}}</span>
                </div>
                <div class="bets-umatched-indicator bets-tab-count"
                     v-if="openBetsUnmatched >0">
                  <span>{{openBetsUnmatched}}</span>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="bets-detached-content" :eager="true">
              <TraderBets v-if="isTrader"></TraderBets>
              <BetsView v-if="!isTrader"></BetsView>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>


      </v-navigation-drawer>
    </div>

    <v-navigation-drawer v-if="bottomDrawEnabled && isInitialStateReady"
                         right
                         fixed
                         floating
                         :hide-overlay="true"
                         permanent
                         v-bind:class="{
                         'is-desktop-betslip':(!bottomDrawEnabled && !shouldDetachBets),
                         'is-mobile-betslip':bottomDrawEnabled}"
                         width="360"
                         height="auto"

    >
      <v-expansion-panels v-if="bottomDrawEnabled"
                          v-model="mobileBetsDrawerActive"

      >
        <v-expansion-panel :key="1">
          <v-expansion-panel-header expand-icon="krypt-arrow-down">
            <div class="mobile-bets-header">
              <span v-if="!isTrader">{{ $t('bets.myBets') | removeDiacriticsFromUppercase }}</span>
              <span v-if="isTrader">{{ $t('trader.forTraders') | removeDiacriticsFromUppercase }}</span>
              <div class="bets-indicator bets-tab-count" v-if="betslipBets.length >0 && !isTrader ">
                <span>{{betslipBets.length}}</span>
              </div>
              <div class="bets-umatched-indicator bets-tab-count"
                   v-if="openBetsUnmatched >0 && !isTrader">
                <span>{{openBetsUnmatched}}</span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="bets-mobile-content">
            <BetsView v-if="!isTrader"></BetsView>
            <TraderBets v-if="isTrader"></TraderBets>

          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-expansion-panels>


    </v-navigation-drawer>

  </div>

</template>
<script>
import LiveCenter from '@/components/LiveCenter';
import BetsView from '@/components/Bets';
import TraderBets from '@/components/TraderBets';

export default {
  name: 'RightSidebar',
  data: function () {
    return {
      showBetSlipMobile: 0,
      betsDrawerActive: false,
      mobileBetsDrawerActive: false
    };
  },
  components: {
    BetsView,
    LiveCenter,
    TraderBets
  },
  mounted:function(){
    window.onpopstate = () => {
      this.mobileBetsDrawerActive = false;
    };
  },
  watch: {
    betslipBets: function (newBets, oldBets) {
      if ((newBets.length > oldBets.length) && !this.isTrader) {
        this.betsDrawerActive = 0;
        this.mobileBetsDrawerActive = 0;
      }
    },
    bettingBotToggler:function () {
      this.betsDrawerActive = 0;
      this.mobileBetsDrawerActive = 0;
    },

  },
  computed: {
    bettingBotToggler: function () {
      return this.$store.state.trader.bettingBot.openBettingBotMobileToggler;
    },
    isTrader:function(){
      return this.$store.state.user.isTrader
    },
    isInitialStateReady: function(){
      return this.$store.state.initialStateReady;
    },
    shouldDetachBets:function(){
      return this.$store.state.navigations.shouldDetachBets;
    },
    openBetsUnmatched: function () {
      let unmatched = 0
      let groupWithUnmatched = Object.values(JSON.parse(JSON.stringify(this.$store.state.bets.active.openBets)))
        .map(function (eventGroup) {
          let filteredEventGroup = eventGroup;
          filteredEventGroup.bets.lay = filteredEventGroup.bets.lay.filter(function (bet) {
            if (bet.betStatus === 'Unmatched') {
              return true;
            } else {
              return false;
            }
          }.bind(this));
          filteredEventGroup.bets.back = filteredEventGroup.bets.back.filter(function (bet) {
            if (bet.betStatus === 'Unmatched') {
              return true;
            } else {
              return false;
            }
          }.bind(this));
          return (filteredEventGroup.bets.back.length + filteredEventGroup.bets.lay.length > 0 ? filteredEventGroup : false);
        }.bind(this)).filter(function (group) {
          return group
        });
      groupWithUnmatched.forEach((group)=>{
        unmatched+=group.bets.lay.length;
        unmatched+=group.bets.back.length;
      });


      return unmatched
    },
    betslipBets: function () {
      return this.$store.state.bets.betslip.layBets.concat(this.$store.state.bets.betslip.backBets);
    },
    liveEventsList: function () {

    },
    betSlipEnabled: {
      get: function () {
        return (this.$store.state.deviceMode !== 'desktop'
          && this.$store.state.deviceMode !== 'laptop' &&
          this.showBetSlipMobile) ||
          (this.$store.state.deviceMode === 'desktop'
            || this.$store.state.deviceMode === 'laptop')
          ;
      },
      set: function (value) {
        return value;
      }
    },
    bottomDrawEnabled: function () {
      return this.$store.state.deviceMode !== 'desktop'
        && this.$store.state.deviceMode !== 'laptop';
    }
  },
  methods: {
    toggleMobileBetSlip: function () {
      if (this.showBetSlipMobile) {

        this.showBetSlipMobile = false;
      } else {
        this.showBetSlipMobile = true;
      }
    },
    hideMobileBetSlip: function () {
      this.showBetSlipMobile = false;
    }
  }
};
</script>

<style scoped>
  .v-navigation-drawer {
    max-height: 100vh;
    transform: none !important;
    position: relative;
  }
  >>>.v-navigation-drawer--fixed {
    z-index: 101;
  }
  .is-mobile-betslip.v-navigation-drawer {
    top: unset !important;
    bottom: 0;
    width: 100% !important;
    border-radius: 4px 4px 0px 0px;
    filter: drop-shadow(0px -4px 20px rgba(0, 0, 0, 0.25));
    max-width: 500px;
    left: 50%;
    transform: translateX(-50%) !important;
  }

  .is-mobile-betslip {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent !important;
  }

  .is-mobile-betslip .v-expansion-panel-header {
    line-height: 19px;
    padding: 16px;
    font-size: 14px;
    font-weight: bold;
    color: var(--grey-600);
    min-height: unset !important;
    border-bottom: 1px var(--grey-200) solid;
  }

  .is-mobile-betslip > .v-navigation-drawer__content .v-expansion-panel-header--active {
    padding: 8px 16px;
  }

  .is-mobile-betslip > >>> .v-navigation-drawer__content {
    max-width: 500px;
    width: 100%;
  }

  .is-mobile-betslip > >>> .v-navigation-drawer__content .v-expansion-panel-header {
    transition: 0.3s padding cubic-bezier(0.25, 0.8, 0.5, 1);
  }

  .is-mobile-betslip > .v-navigation-drawer__content .v-expansion-panel--active {
    border-radius: 0px !important;
  }

  .is-mobile-betslip > .v-navigation-drawer__content .v-expansion-panel-header--active >>> .v-expansion-panel-header__icon > .v-icon {
    transform: rotate(0deg) !important;
  }

  .is-mobile-betslip > .v-navigation-drawer__content .v-expansion-panel-header >>> .v-expansion-panel-header__icon > .v-icon {
    color: var(--grey-900);
    transform: rotate(-180deg);
    margin-left: 16px;
  }

  .is-mobile-betslip .v-expansion-panels {
    border-radius: 4px 4px 0 0;
  }

  /* kill vuetify on focus highlight from expansion header */
  .v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus::before {
    opacity: 0;
  }

  >>> .v-navigation-drawer__content::-webkit-scrollbar {
    display: none;
  }

  >>> .v-navigation-drawer {
    overflow: visible !important;
  }

  >>> .v-navigation-drawer__content {
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow: initial;
  }

  .right-sidebar-desktop {
    position: fixed;
    right: 0;
    width: 360px;
    min-height: 100vh;
    top: 0;
    background-color: white;
    display: flex;
    flex-direction: column;
    max-height: 100vh;
    height: 100vh;
  }

  .right-sidebar-desktop.remove-white-background {
    background-color: unset;
  }

  .mobile-bets-header {
    max-width: calc(100% - 40px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    text-transform: uppercase;
  }

  .mobile-bets-header > span{
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bets-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--primary);
    border-radius: 16px;
    margin-left: 8px;
    height: max-content;
  }

  .bets-umatched-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--cyborg);
    border-radius: 16px;
    margin-left: 8px;
    height: max-content;
  }

  >>> .v-expansion-panel-header--active .bets-umatched-indicator {
    display: none;
  }

  >>> .v-expansion-panel-header--active .bets-indicator {
    display: none;
  }

  .bets-tab-count > span {
    display: flex;
    align-items: center;
    text-align: center;
    user-select: none;
    line-height: 14px;
    color: white;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 4px;
  }

  .bets-tab-count {
    min-width: 20px;
  }

  .is-desktop-betslip-detached{
    position: absolute;
    top: unset !important;
    bottom: 0;
    max-height: calc(100vh - 40px);
    border-radius: 4px 4px 0 0;
  }

  .bets-detached-content > >>> .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }

  .bets-detached-content {
    height: calc(100vh - 92px); /* changed from 52px because of the 40px we created at the top */
  }

  .is-desktop-betslip-detached.v-navigation-drawer {
    filter: drop-shadow(0px -4px 20px rgba(0, 0, 0, 0.25));
  }

  .is-desktop-betslip-detached .v-expansion-panel-header {
    line-height: 19px;
    padding: 16px;
    font-size: 14px;
    font-weight: bold;
    color: var(--grey-600);
    min-height: unset !important;
    border-bottom: 1px var(--grey-200) solid;
  }

  .is-desktop-betslip-detached > >>> .v-navigation-drawer__content {
    max-width: 500px;
    width: 100%;
  }

  /* not needed because it will not open to the top
  .is-desktop-betslip-detached > .v-navigation-drawer__content .v-expansion-panel--active {
    border-radius: 0px !important;
  } */

  .is-desktop-betslip-detached > .v-navigation-drawer__content .v-expansion-panel-header--active >>> .v-expansion-panel-header__icon > .v-icon {
    transform: rotate(0deg) !important;
  }

  .is-desktop-betslip-detached > .v-navigation-drawer__content .v-expansion-panel-header >>> .v-expansion-panel-header__icon > .v-icon {
    color: var(--grey-900);
    transform: rotate(-180deg);
    margin-left: 16px;
  }

  .is-desktop-betslip-detached .v-expansion-panels {
    border-radius: 4px 4px 0 0;
  }

  .detached-bets-header {
    max-width: calc(100% - 40px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    text-transform: uppercase;
  }

  .detached-bets-header > span{
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /*Media Queries*/

  @media screen and (max-width: 1279px) {
    .v-navigation-drawer {
      position: fixed !important;
    }
  }

  @media screen and (max-width: 1279px) {
    .bets-mobile-content > >>> .v-expansion-panel-content__wrap {
      padding: 0 !important;
    }

    .bets-mobile-content {
      height: calc(100vh - 36px);
    }
  }

</style>
